function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  cx: 18.409,
  cy: 18.409,
  r: 18.409,
  transform: "translate(214.679 310.048)",
  fill: "#f2f2f2"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  cx: 11.409,
  cy: 11.409,
  r: 11.409,
  transform: "translate(158.679 529.048)",
  fill: "#f2f2f2"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1",
  "data-name": "Rectangle 1",
  width: 140,
  height: 2,
  transform: "translate(379.997 21.5)",
  fill: "#f2f2f2"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2",
  "data-name": "Rectangle 2",
  width: 2,
  height: 18.5,
  transform: "translate(417.997 3.5)",
  fill: "#f2f2f2"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3",
  "data-name": "Rectangle 3",
  width: 2,
  height: 18.5,
  transform: "translate(478.997 3.5)",
  fill: "#f2f2f2"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_4",
  "data-name": "Rectangle 4",
  width: 140,
  height: 2,
  transform: "translate(605.997 505.5)",
  fill: "#f2f2f2"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  width: 2,
  height: 18.5,
  transform: "translate(643.997 487.5)",
  fill: "#f2f2f2"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 2,
  height: 18.5,
  transform: "translate(704.997 487.5)",
  fill: "#f2f2f2"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7",
  "data-name": "Rectangle 7",
  width: 140,
  height: 2,
  transform: "translate(612.997 200.5)",
  fill: "#f2f2f2"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_8",
  "data-name": "Rectangle 8",
  width: 2,
  height: 18.5,
  transform: "translate(650.997 182.5)",
  fill: "#f2f2f2"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9",
  "data-name": "Rectangle 9",
  width: 2,
  height: 18.5,
  transform: "translate(711.997 182.5)",
  fill: "#f2f2f2"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_10",
  "data-name": "Rectangle 10",
  width: 140,
  height: 2,
  transform: "translate(612.997 128.5)",
  fill: "#f2f2f2"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_11",
  "data-name": "Rectangle 11",
  width: 2,
  height: 18.5,
  transform: "translate(650.997 110.5)",
  fill: "#f2f2f2"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_12",
  "data-name": "Rectangle 12",
  width: 2,
  height: 18.5,
  transform: "translate(711.997 110.5)",
  fill: "#f2f2f2"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13",
  "data-name": "Rectangle 13",
  width: 140,
  height: 2,
  transform: "translate(305.997 138.5)",
  fill: "#f2f2f2"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_14",
  "data-name": "Rectangle 14",
  width: 2,
  height: 18.5,
  transform: "translate(343.997 120.5)",
  fill: "#f2f2f2"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_15",
  "data-name": "Rectangle 15",
  width: 2,
  height: 18.5,
  transform: "translate(404.997 120.5)",
  fill: "#f2f2f2"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  width: 140,
  height: 2,
  transform: "translate(203.997 91.5)",
  fill: "#f2f2f2"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_17",
  "data-name": "Rectangle 17",
  width: 2,
  height: 18.5,
  transform: "translate(241.997 73.5)",
  fill: "#f2f2f2"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18",
  "data-name": "Rectangle 18",
  width: 2,
  height: 18.5,
  transform: "translate(302.997 73.5)",
  fill: "#f2f2f2"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_19",
  "data-name": "Rectangle 19",
  width: 140,
  height: 2,
  transform: "translate(140.997 276.5)",
  fill: "#f2f2f2"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_20",
  "data-name": "Rectangle 20",
  width: 2,
  height: 18.5,
  transform: "translate(178.997 258.5)",
  fill: "#f2f2f2"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_21",
  "data-name": "Rectangle 21",
  width: 2,
  height: 18.5,
  transform: "translate(239.997 258.5)",
  fill: "#f2f2f2"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_22",
  "data-name": "Rectangle 22",
  width: 140,
  height: 2,
  transform: "translate(70.997 480.5)",
  fill: "#f2f2f2"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_23",
  "data-name": "Rectangle 23",
  width: 2,
  height: 18.5,
  transform: "translate(108.997 462.5)",
  fill: "#f2f2f2"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_24",
  "data-name": "Rectangle 24",
  width: 2,
  height: 18.5,
  transform: "translate(169.997 462.5)",
  fill: "#f2f2f2"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_25",
  "data-name": "Rectangle 25",
  width: 140,
  height: 2,
  transform: "translate(732.997 396.5)",
  fill: "#f2f2f2"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_26",
  "data-name": "Rectangle 26",
  width: 2,
  height: 18.5,
  transform: "translate(770.997 378.5)",
  fill: "#f2f2f2"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_27",
  "data-name": "Rectangle 27",
  width: 2,
  height: 18.5,
  transform: "translate(831.997 378.5)",
  fill: "#f2f2f2"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_28",
  "data-name": "Rectangle 28",
  width: 140,
  height: 2,
  transform: "translate(691.997 268.5)",
  fill: "#f2f2f2"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_29",
  "data-name": "Rectangle 29",
  width: 2,
  height: 18.5,
  transform: "translate(791.997 270)",
  fill: "#f2f2f2"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_30",
  "data-name": "Rectangle 30",
  width: 2,
  height: 18.5,
  transform: "translate(730.997 270)",
  fill: "#f2f2f2"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_31",
  "data-name": "Rectangle 31",
  width: 140,
  height: 2,
  transform: "translate(13.997 118.5)",
  fill: "#f2f2f2"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_32",
  "data-name": "Rectangle 32",
  width: 2,
  height: 18.5,
  transform: "translate(113.997 120)",
  fill: "#f2f2f2"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_33",
  "data-name": "Rectangle 33",
  width: 2,
  height: 18.5,
  transform: "translate(52.997 120)",
  fill: "#f2f2f2"
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_34",
  "data-name": "Rectangle 34",
  width: 140,
  height: 2,
  transform: "translate(22.997 380.5)",
  fill: "#f2f2f2"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_35",
  "data-name": "Rectangle 35",
  width: 2,
  height: 18.5,
  transform: "translate(122.997 382)",
  fill: "#f2f2f2"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_36",
  "data-name": "Rectangle 36",
  width: 2,
  height: 18.5,
  transform: "translate(61.997 382)",
  fill: "#f2f2f2"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_37",
  "data-name": "Rectangle 37",
  width: 140,
  height: 2,
  transform: "translate(463.997 53.5)",
  fill: "#f2f2f2"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_38",
  "data-name": "Rectangle 38",
  width: 2,
  height: 18.5,
  transform: "translate(563.997 55)",
  fill: "#f2f2f2"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_39",
  "data-name": "Rectangle 39",
  width: 2,
  height: 18.5,
  transform: "translate(502.997 55)",
  fill: "#f2f2f2"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_40",
  "data-name": "Rectangle 40",
  width: 140,
  height: 2,
  transform: "translate(70.997 192.5)",
  fill: "#f2f2f2"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_41",
  "data-name": "Rectangle 41",
  width: 2,
  height: 18.5,
  transform: "translate(108.997 174.5)",
  fill: "#f2f2f2"
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_42",
  "data-name": "Rectangle 42",
  width: 2,
  height: 18.5,
  transform: "translate(169.997 174.5)",
  fill: "#f2f2f2"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M370.749,300.408v471h436v-471Zm218,34a15,15,0,1,1,15-15,15,15,0,0,1-15,15Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#3f3d56"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M174.506,731.205c6.914,25.558,30.6,41.387,30.6,41.387s12.472-25.609,5.558-51.167-30.6-41.387-30.6-41.387S167.592,705.647,174.506,731.205Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#3f3d56"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M184.666,725.712c18.972,18.469,21.289,46.859,21.289,46.859s-28.443-1.553-47.415-20.021-21.289-46.859-21.289-46.859S165.694,707.244,184.666,725.712Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#0cd8b9"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M0,0H909V2H0Z",
  transform: "translate(16.497 643)",
  fill: "#3f3d56"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M329.249,708.746a22.031,22.031,0,0,0-14.031-20.5,22,22,0,1,0-15.938,0,21.991,21.991,0,0,0,0,41,22,22,0,1,0,15.938,0,22.031,22.031,0,0,0,14.031-20.5Zm-42-41a20,20,0,1,1,24.513,19.467,22.023,22.023,0,0,0-9.026,0A20.021,20.021,0,0,1,287.249,667.746Zm40,82a20,20,0,1,1-24.513-19.467,22.023,22.023,0,0,0,9.026,0,20.021,20.021,0,0,1,15.487,19.467Zm-15.487-21.533a22.025,22.025,0,0,0-9.026,0,19.979,19.979,0,0,1,0-38.935,22.023,22.023,0,0,0,9.026,0,19.979,19.979,0,0,1,0,38.935Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#3f3d56"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M648.248,398.908h-229a7,7,0,1,1,0-14h229a7,7,0,0,1,0,14Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#f2f2f2"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M648.248,470.908h-229a7,7,0,1,1,0-14h229a7,7,0,0,1,0,14Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#f2f2f2"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M648.248,542.908h-229a7,7,0,1,1,0-14h229a7,7,0,0,1,0,14Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#f2f2f2"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M648.248,614.908h-229a7,7,0,1,1,0-14h229a7,7,0,0,1,0,14Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#f2f2f2"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M648.248,686.908h-229a7,7,0,1,1,0-14h229a7,7,0,0,1,0,14Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#f2f2f2"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M608.248,398.908h-190a7,7,0,1,1,0-14h190a7,7,0,0,1,0,14Z",
  transform: "translate(-137.251 -127.408)",
  fill: "rgba(12,216,185,0.84)"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M549.248,470.908h-131a7,7,0,1,1,0-14h131a7,7,0,1,1,0,14Z",
  transform: "translate(-137.251 -127.408)",
  fill: "rgba(12,216,185,0.84)"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M477.249,542.908h-59a7,7,0,0,1,0-14h59a7,7,0,0,1,0,14Z",
  transform: "translate(-137.251 -127.408)",
  fill: "rgba(12,216,185,0.84)"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M626.248,614.908h-208a7,7,0,1,1,0-14h208a7,7,0,0,1,0,14Z",
  transform: "translate(-137.251 -127.408)",
  fill: "rgba(12,216,185,0.84)"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M580.248,686.908h-162a7,7,0,1,1,0-14h162a7,7,0,0,1,0,14Z",
  transform: "translate(-137.251 -127.408)",
  fill: "rgba(12,216,185,0.84)"
});

var _ref61 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_44",
  "data-name": "Rectangle 44",
  width: 2,
  height: 14,
  transform: "translate(603.997 257.5)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M758.248,399.908a8,8,0,1,1,8-8,8,8,0,0,1-8,8Zm0-14a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(-137.251 -127.408)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref63 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_45",
  "data-name": "Rectangle 45",
  width: 2,
  height: 14,
  transform: "translate(603.997 329.5)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M758.248,471.908a8,8,0,1,1,8-8,8,8,0,0,1-8,8Zm0-14a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(-137.251 -127.408)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref65 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_46",
  "data-name": "Rectangle 46",
  width: 2,
  height: 14,
  transform: "translate(603.997 401.5)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M758.248,543.908a8,8,0,1,1,8-8A8,8,0,0,1,758.248,543.908Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,758.248,529.908Z",
  transform: "translate(-137.251 -127.408)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_47",
  "data-name": "Rectangle 47",
  width: 2,
  height: 14,
  transform: "translate(603.997 473.5)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  id: "Path_18",
  "data-name": "Path 18",
  d: "M758.248,615.908a8,8,0,1,1,8-8A8,8,0,0,1,758.248,615.908Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,758.248,601.908Z",
  transform: "translate(-137.251 -127.408)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref69 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_48",
  "data-name": "Rectangle 48",
  width: 2,
  height: 14,
  transform: "translate(603.997 545.5)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M758.248,687.908a8,8,0,1,1,8-8,8,8,0,0,1-8,8Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,758.248,673.908Z",
  transform: "translate(-137.251 -127.408)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref71 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3",
  "data-name": "Ellipse 3",
  cx: 4,
  cy: 4,
  r: 4,
  transform: "translate(616.997 260.5)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref72 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_4",
  "data-name": "Ellipse 4",
  cx: 4,
  cy: 4,
  r: 4,
  transform: "translate(616.997 476.5)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref73 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_5",
  "data-name": "Ellipse 5",
  cx: 4,
  cy: 4,
  r: 4,
  transform: "translate(616.997 548.5)",
  fill: "rgba(8,253,216,0.84)"
});

var _ref74 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_6",
  "data-name": "Ellipse 6",
  cx: 7,
  cy: 7,
  r: 7,
  transform: "translate(444.497 185)",
  fill: "#3f3d56"
});

var _ref75 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7",
  "data-name": "Ellipse 7",
  cx: 7,
  cy: 7,
  r: 7,
  transform: "translate(444.497)",
  fill: "#3f3d56"
});

var _ref76 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_49",
  "data-name": "Rectangle 49",
  width: 2,
  height: 185,
  transform: "translate(450.497 7)",
  fill: "#3f3d56"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M993.865,511.887v24.775s5.964,39.915,5.964,74.783S990.2,727.52,990.2,727.52s-19.269,6.882-20.646-3.67-5.047-66.525-5.047-74.783-16.058-71.113-16.058-71.113L938.351,647.69s3.212,82.583,0,84.877-18.811,6.423-20.646,2.294-11.47-92.676-11.47-92.676-7.8-115.616-3.212-122.5,8.717-12.387,8.717-12.387S977.348,491.241,993.865,511.887Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#2f2e41"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M987.9,724.767l1.151,7.479a73.672,73.672,0,0,1,.752,7.7c.179,3.757.8,9.545,2.945,10.463,3.212,1.376,24.056,18.956,9.375,19.873s-22.026,2.5-26.375-.873c-5.141-3.992.682-2.184-1.612-2.184s-5.047,0-5.964-3.67,1.376-10.094,1.376-10.094V724.767Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#2f2e41"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M919.4,724.408l-1.151,7.479a73.653,73.653,0,0,0-.752,7.7c-.179,3.757-.8,9.545-2.945,10.463-3.212,1.376-24.056,18.956-9.375,19.873s22.026,2.5,26.375-.873c5.141-3.992-.682-2.184,1.612-2.184s5.047,0,5.964-3.67-1.376-10.094-1.376-10.094V724.408Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#2f2e41"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M932.387,312.77s7.8,19.269,13.3,22.481,2.753,17.893,2.753,17.893l-13.764,19.269H923.67l-13.3-22.94s-.918-15.14-3.67-18.811S932.387,312.77,932.387,312.77Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#ffb9b9"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M932.387,312.77s7.8,19.269,13.3,22.481,2.753,17.893,2.753,17.893l-13.764,19.269H923.67l-13.3-22.94s-.918-15.14-3.67-18.811S932.387,312.77,932.387,312.77Z",
  transform: "translate(-137.251 -127.408)",
  opacity: 0.1
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M943.857,352.226l20.646,4.588,15.14,152.32s-8.258,1.376-16.517,12.387-18.352,9.176-23.4,6.423-25.234-10.552-25.693-13.764.918-59.643.918-59.643l-12.847-88.088,6.423-9.635H920l9.176,7.8Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#0cd8b9"
});

var _ref83 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_8",
  "data-name": "Ellipse 8",
  cx: 23.857,
  cy: 23.857,
  r: 23.857,
  transform: "translate(751.55 161.505)",
  fill: "#ffb9b9"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M947.068,344.427s44.962,4.588,49.091,14.223-2.753,52.3-2.753,52.3,16.517,37.162,16.058,45.879,15.6,68.36-1.835,61.478-11.929-24.775-20.646-11.929S974.6,517.392,974.6,517.392s-8.717,14.223-11.47,12.846-4.588-11.929,1.376-16.975,5.047-13.764-6.423-30.28-23.4-103.229-16.516-116.534S947.068,344.427,947.068,344.427Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#575a89"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M856.614,393.2l-7.8,7.341-9.635-6.423,4.13-9.635Z",
  fill: "#ffb9b9"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M914.035,352.226s-34.868,12.846-34.868,26.61,21.1,73.866,21.1,73.866,0,15.6-.918,19.269S884,507.654,896.6,510.51c7.865,1.783,14.327,6.466,14.911,13.076.693,7.849-5.315,17.755-4.817,19.5.918,3.212,6.423,7.8,5.964,5.506s3.67-35.327,10.094-50.008S920,385.259,918.164,372.413A141.985,141.985,0,0,0,914.035,352.226Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#575a89"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M758.432,392.278l8.258,19.729,6.194-12.617-7.112-15.829Z",
  fill: "#ffb9b9"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M939.536,327.551s7.532,3.112,12.12,3.112,23.4,9.635,16.975,15.6-16.058,7.341-20.646,16.058-6.882,10.094-6.882,10.094l-8.168-10.973s11.38-12.885,10.921-17.014S939.536,327.551,939.536,327.551Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#08fdd8"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M909.125,338.582s-5.643,2.175-7.019,5.845-10.094,10.552-6.423,12.387,19.728,9.176,22.94,10.552,9.2-3.9,9.2-3.9-8.05-4.583-8.05-7.794S909.125,338.582,909.125,338.582Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#08fdd8"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M890.178,372.413l-11.011,2.753s-15.14,67.9-10.552,84.877,26.151,67.9,26.151,67.9l13.764-16.058s-6-36.515-9.425-38.9-1.127-7.435-1.127-8.811,1.376-.459-1.835-3.67,11.929-21.1,7.8-26.151S890.178,372.413,890.178,372.413Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#575a89"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M998.682,385.03l-6.652-25s17.893,12.846,21.563,31.657,17.893,56.432,8.717,72.948-25.234,64.231-30.739,63.314-18.811-12.387-19.269-14.223,23.857-44.044,20.187-47.256-2.753-11.47,0-13.3,5.964-10.552,3.67-10.094-9.176-4.129-7.8-9.176-6.882-39-6.882-39Z",
  transform: "translate(-137.251 -127.408)",
  opacity: 0.1
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M989.736,356.814l6.423,1.835s17.893,12.846,21.563,31.657,17.893,56.432,8.717,72.948-25.234,64.231-30.739,63.314-18.811-12.387-19.269-14.223,23.857-44.044,20.187-47.256-2.753-11.47,0-13.3,5.964-10.552,3.67-10.094-9.176-4.129-7.8-9.176-6.882-39-6.882-39Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#575a89"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M931.172,291.235l4.475-1.627s-9.356-9.356-22.373-8.542l3.661-3.661s-8.949-3.254-17.085,5.288c-4.277,4.491-9.225,9.769-12.31,15.715h-4.792l2,4-7,4,7.185-.719a20.184,20.184,0,0,0,.68,10.36l1.627,4.475s6.509-13.017,6.509-14.644v4.068s4.475-3.661,4.475-6.1l2.441,2.847,1.22-4.475,15.051,4.475-2.441-3.661,9.356,1.22-3.661-4.475s10.576,5.288,10.983,9.763,5.695,10.169,5.695,10.169l2.441-4.068S942.969,297.337,931.172,291.235Z",
  transform: "translate(-137.251 -127.408)",
  fill: "#2f2e41"
});

var _ref94 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  cx: 3.5,
  cy: 5.5,
  rx: 3.5,
  ry: 5.5,
  transform: "translate(789.497 177)",
  fill: "#ffb9b9"
});

function SvgSkillsImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "skills-img",
    xmlns: "http://www.w3.org/2000/svg",
    width: 925.497,
    height: 645.185,
    viewBox: "0 0 925.497 645.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsImg);
export default __webpack_public_path__ + "static/media/skills-img.c301472f.svg";
export { ForwardRef as ReactComponent };